export function formatDate(date: number): string {
    const hours = Math.floor(date / 3600 / 1000);
    const minutes = Math.floor((date - 3600 * 1000 * hours) / 60 / 1000);
    const seconds = (date / 1000 % 60).toFixed(2);

    if (hours > 0) {
        return `${hours}h ${minutes}m ${seconds}s`;
    }

    if (minutes > 0) {
        return `${minutes}m ${seconds}s`;
    }

    return `${seconds}s`;
};